import { Badge } from "@mantine/core";

function ProceduresCodeBadge({ code }: { code: string }) {
  return (
    <Badge fz="md" fw={600} miw={80} size="lg" c="black" radius="sm" bg="gray.1">
      {code}
    </Badge>
  );
}

export default ProceduresCodeBadge;
